import React, { useCallback } from 'react';
import css from './styles.module.scss';
import { StepControls } from '~/common/step-controls';
import { useForm } from 'react-hook-form';
import { INewDealStepThreeFormInputs } from '~/models/deals/new-deal/formInputs';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { Button, Grid, Typography } from '@material-ui/core';
import { newDealFormNextStep } from '~/features/dashboard/store/actions';
import classNames from 'classnames';
import { TextInput } from '~/features/dashboard/components/add-deal/components/text-input';

interface Step_4Props {
    prevStep: () => void;
}

export const Step_4: React.FC<Step_4Props> = ({ prevStep }) => {
    const dispatch = useThunkDispatch();

    const {
        handleSubmit,
        register,
    } = useForm<INewDealStepThreeFormInputs>({
        defaultValues: {},
    });

    const onSubmit = useCallback(
        (data: INewDealStepThreeFormInputs) => {
            dispatch(newDealFormNextStep());
        },
        [dispatch]
    );
    return (
        <div className={css.module}>
            <form className={css.form} onSubmit={handleSubmit(onSubmit)}>
                <Typography align={'left'} variant={'h6'} className={classNames(css.bold, css.title)}>
                    test - test the Statement Received
                </Typography>
                <Grid container spacing={3} className={css.container}>
                    <Grid item xs={5} className={css.box}>
                        <label className="customlabel bold">Gross Licensing</label>
                    </Grid>
                    <Grid item xs={4} className={css.box}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={3} className={css.box}>
                        <Button className={css.button}>Details</Button>
                    </Grid>

                    <Grid item xs={3} className={css.box}>
                        <label className="customlabel bold">Distribution Fee</label>
                        <label className="customlabel bold">%</label>
                    </Grid>
                    <Grid item xs={2}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={4} className={css.box}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={3} className={css.box}>
                        <Button className={css.button}>Details</Button>
                    </Grid>

                    <Grid item xs={5} className={css.box}>
                        <label className="customlabel bold">Other Deductions</label>
                    </Grid>
                    <Grid item xs={4} className={css.box}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={3} className={css.box}>
                        <Button className={css.button}>Details</Button>
                    </Grid>

                    <Grid item xs={5} className={css.box}>
                        <label className="customlabel bold">New Digital</label>
                    </Grid>
                    <Grid item xs={4} className={css.box}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                </Grid>
                <StepControls onPrevClick={prevStep} className={css.nextButton} />
            </form>
        </div>
    );
};
